(function () {
  const STAGE_COUNT = 4;
  const STAGE_SECONDS = [12, 15, 18, 21];
  const SPEEDS = [320, 380, 450, 560];
  const STAGE_LENGTHS = SPEEDS.map(function (s, i) {
    return s * STAGE_SECONDS[i];
  });
  const TOTAL_DISTANCE = STAGE_LENGTHS.reduce(function (sum, len) {
    return sum + len;
  }, 0);
  const TOTAL_SECONDS = STAGE_SECONDS.reduce(function (sum, s) {
    return sum + s;
  }, 0);
  const REACT = [0.68, 0.58, 0.46, 0.42];
  const LAND_OFFSET = { base: 36, per: 0.72 };
  const RISE_OFFSET = { base: 60, per: 0.28 };
  const GRAVITY = 2500;
  const JUMP_V = -720;
  const PERCENTS = [10, 20, 30, 40];
  const WORLD_W = 900;
  const WORLD_H = 460;
  const GROUND_H = 48;
  const CHAR_METRICS = {
    mars: { frame: 48, draw: 96, duckDraw: 62 },
    pluto: { frame: 48, draw: 96, duckDraw: 62 },
  };
  const DUCK_CLEAR = 38;
  const HANG_H = 360;
  const DEATH_SECONDS = 0.55;
  const SPAWN_START = 0.6;
  const LEVEL_UP_SECONDS = 0.7;
  const SIGN_GOLD = [255, 214, 80];
  const SIGN_GOLD_BLINKS = 3;
  const SPEED_UP_CLEAR = 1.15;
  const CHECKPOINT_LEAD = 0.3;
  const CELEBRATE_SECONDS = 10;
  const BONUS_SPAWN_STAGE = 5;
  const OBS_DEFS = {
    spike: { w: 28, h: 36 },
    spike2: { w: 36, h: 48 },
    vinyl: { w: 34, h: 34 },
    cable: { w: 20, h: 58 },
    robot: { w: 40, h: 40 },
    headphones: { w: 44, h: 28 },
    box: { w: 28, h: 28 },
    box2: { w: 32, h: 32 },
    capsule: { w: 32, h: 48 },
    hangpipe: { w: 46, h: HANG_H, hang: true },
    hangflag: { w: 26, h: HANG_H, hang: true },
    hangboard: { w: 44, h: HANG_H, hang: true },
  };
  const GROUND_POOL = {
    1: ["spike", "vinyl", "box"],
    2: ["spike", "vinyl", "robot", "box", "box2"],
    3: ["spike", "spike2", "robot", "box2", "capsule"],
    4: ["spike2", "robot", "cable", "vinyl", "box2", "capsule"],
    5: ["spike2", "robot", "cable", "capsule"],
  };
  const HANG_POOL = {
    1: ["hangpipe"],
    2: ["hangpipe", "hangflag"],
    3: ["hangpipe", "hangflag"],
    4: ["hangpipe", "hangflag"],
    5: ["hangpipe", "hangflag"],
  };
  const PATTERNS = {
    1: [["ground"], ["ground", "ground@26"], ["ground"], ["hang"], ["ground"], ["ground", "ground@24"]],
    2: [["ground"], ["hang"], ["ground", "ground@34"], ["hang"], ["ground", "hang@land"], ["hang"]],
    3: [["ground", "hang@land"], ["hang", "ground@rise"], ["ground", "ground@26"], ["hang", "ground@rise"], ["hang"], ["ground", "hang@land"]],
    4: [["ground", "hang@land"], ["hang", "ground@rise"], ["ground", "ground@26"], ["hang", "hang@32"], ["ground", "hang@land"], ["hang", "ground@rise"], ["hang"]],
    5: [["ground", "hang@land"], ["hang", "ground@rise"], ["ground", "ground@28"], ["hang", "hang@32"], ["ground", "hang@land"], ["hang", "ground@rise"], ["hang"]],
  };
  const NEAR_SIGNS = [
    { kind: "billboard", sx: 112, sy: 158 },
    { kind: "poster", sx: 288, sy: 148 },
  ];
  const FAR_SIGNS = [
    { kind: "billboard", sx: 192, sy: 176 },
  ];
  const COOKIE_KEY = "ovani_game_id";
  const CHAR_KEY = "ovani-runner-character";
  const HIGHSCORE_KEY = "ovani-runner-highscore";
  const MONTH_TZ = "America/Los_Angeles";
  const CHAR_ALIAS = { biker: "mars", punk: "mars", cyborg: "pluto", cat: "mars", titan: "mars", moon: "mars" };
  const CHARACTERS = [
    { id: "mars", label: "Mars" },
    { id: "pluto", label: "Pluto" },
  ];
  const MUSIC_IDS = ["urgent", "vanquish", "bruh", "nini"];
  const MUSIC_LAYERS = ["1", "2", "main"];
  const MUTE_KEY = "ovani-runner-mute";
  const VOLUME_KEY = "ovani-runner-volume";
  const MUSIC_FADE_MS = 420;
  const STEP_GAIN = 0.38;
  const JUMP_LAND_GAIN = Math.pow(10, -6 / 20);
  const MINUS_4_DB = Math.pow(10, -4 / 20);
  const LAND_SFX_LEAD = 0.045;

  function createRunnerAudio(art) {
    const sfx = (art && art.sfx) || {};
    const music = (art && art.music) || {};
    const AC = window.AudioContext || window.webkitAudioContext;
    let ctx = null;
    let masterGain = null;
    let sfxGain = null;
    let musicMaster = null;
    const layerGains = { "1": null, "2": null, main: null };
    const sources = { "1": null, "2": null, main: null };
    const buffers = { "1": null, "2": null, main: null };
    const bufferCache = {};
    const bufferReady = {};
    let songIndex = -1;
    let musicPlaying = false;
    let ignoreMusicEnded = false;
    let musicPlayToken = 0;
    let currentIntensity = "1";
    let muted = false;
    let volume = 1;
    let sfxQueued = false;
    let clickFlip = 0;
    let gainFlip = 0;
    let stepFlip = 0;
    let lastStepBucket = -1;
    let holdMain = false;
    let slideSrc = null;
    let slideGain = null;
    let slideWanted = false;
    let slideLoading = false;
    const muteListeners = [];
    const songListeners = [];

    try {
      muted = localStorage.getItem(MUTE_KEY) === "1";
    } catch {
      muted = false;
    }

    function clampVolume(value) {
      const n = Number(value);
      if (!Number.isFinite(n)) return 1;
      return Math.max(0, Math.min(1, n));
    }

    try {
      const stored = localStorage.getItem(VOLUME_KEY);
      if (stored != null && stored !== "") volume = clampVolume(stored);
    } catch {
      volume = 1;
    }

    function masterOutput() {
      return muted ? 0 : volume;
    }

    function isAvailable() {
      return Boolean(AC);
    }

    function setGainNow(node, value) {
      if (!node || !ctx) return;
      const t = ctx.state === "running" ? ctx.currentTime : 0;
      node.gain.cancelScheduledValues(t);
      node.gain.setValueAtTime(value, t);
    }

    function ensureContext() {
      if (!isAvailable()) return null;
      if (ctx) return ctx;
      ctx = new AC();
      masterGain = ctx.createGain();
      sfxGain = ctx.createGain();
      musicMaster = ctx.createGain();
      sfxGain.gain.value = 1;
      musicMaster.gain.value = 0.72;
      sfxGain.connect(masterGain);
      musicMaster.connect(masterGain);
      masterGain.connect(ctx.destination);
      MUSIC_LAYERS.forEach(function (key) {
        layerGains[key] = ctx.createGain();
        layerGains[key].gain.value = key === "1" ? 1 : 0;
        layerGains[key].connect(musicMaster);
      });
      setGainNow(masterGain, masterOutput());
      return ctx;
    }

    function resume() {
      const context = ensureContext();
      if (context && context.state === "suspended") {
        return context.resume().then(function () {
          return context;
        }).catch(function () {
          return context;
        });
      }
      return Promise.resolve(context);
    }

    function measureLeadingSilence(buffer) {
      if (!buffer) return 0;
      const channel = buffer.getChannelData(0);
      const len = channel.length;
      if (len === 0) return 0;
      let peak = 0;
      for (let i = 0; i < len; i += 1) {
        const amp = Math.abs(channel[i]);
        if (amp > peak) peak = amp;
      }
      if (peak < 0.001) return 0;
      const thresh = peak * 0.05;
      const maxSkip = Math.min(Math.floor(buffer.sampleRate * 0.05), len);
      for (let i = 0; i < maxSkip; i += 1) {
        if (Math.abs(channel[i]) >= thresh) return i / buffer.sampleRate;
      }
      return 0;
    }

    function fetchBuffer(url) {
      if (!url) return Promise.resolve(null);
      if (bufferReady[url]) return Promise.resolve(bufferReady[url].buffer);
      if (bufferCache[url]) return bufferCache[url];
      bufferCache[url] = resume()
        .then(function (context) {
          if (!context) return null;
          return fetch(url).then(function (res) {
            if (!res.ok) throw new Error("audio fetch failed");
            return res.arrayBuffer();
          }).then(function (arr) {
            return context.decodeAudioData(arr.slice(0));
          }).then(function (buffer) {
            if (buffer) {
              bufferReady[url] = { buffer: buffer, trim: measureLeadingSilence(buffer) };
            }
            return buffer;
          });
        })
        .catch(function () {
          delete bufferCache[url];
          delete bufferReady[url];
          return null;
        });
      return bufferCache[url];
    }

    function preloadSfx() {
      if (sfxQueued) return;
      sfxQueued = true;
      Object.keys(sfx).forEach(function (key) {
        fetchBuffer(sfx[key]);
      });
    }

    function unlock() {
      resume();
      preloadSfx();
    }

    function playBuffer(buffer, dest, gainValue, trimOffset) {
      if (!ctx || !buffer || muted) return;
      const src = ctx.createBufferSource();
      src.buffer = buffer;
      if (gainValue != null && gainValue !== 1) {
        const g = ctx.createGain();
        g.gain.value = gainValue;
        src.connect(g);
        g.connect(dest);
      } else {
        src.connect(dest);
      }
      const offset = trimOffset || 0;
      try {
        src.start(ctx.currentTime, offset);
      } catch {
        // ignore
      }
    }

    function playSfx(name, gainValue) {
      const url = sfx[name];
      if (!url) return;
      const ready = bufferReady[url];
      if (ready) {
        resume().then(function (context) {
          if (!context || muted) return;
          playBuffer(ready.buffer, sfxGain, gainValue, ready.trim);
        });
        return;
      }
      resume().then(function () {
        return fetchBuffer(url);
      }).then(function () {
        const entry = bufferReady[url];
        if (entry) playBuffer(entry.buffer, sfxGain, gainValue, entry.trim);
      });
    }

    function playClick(gainValue) {
      playSfx(clickFlip % 2 === 0 ? "clickA" : "clickB", gainValue);
      clickFlip += 1;
    }

    function playGain() {
      const names = ["gainA", "gainB", "gainC"];
      playSfx(names[gainFlip % 3]);
      gainFlip += 1;
    }

    function playStep() {
      const names = ["stepA", "stepB", "stepC", "stepD"];
      playSfx(names[stepFlip % 4], STEP_GAIN);
      stepFlip += 1;
    }

    function playCharSfx(charId, kind, gainValue) {
      const who = charId === "pluto" ? "pluto" : "mars";
      playSfx(who + kind, gainValue);
    }

    function stopSlideLoop() {
      slideWanted = false;
      slideLoading = false;
      if (!slideSrc) return;
      try {
        slideSrc.stop();
      } catch {
        // ignore
      }
      try {
        slideSrc.disconnect();
      } catch {
        // ignore
      }
      if (slideGain) {
        try {
          slideGain.disconnect();
        } catch {
          // ignore
        }
      }
      slideSrc = null;
      slideGain = null;
    }

    function startSlideLoop(buffer) {
      if (!ctx || !buffer || muted || !slideWanted || slideSrc) return;
      const src = ctx.createBufferSource();
      src.buffer = buffer;
      src.loop = true;
      const g = ctx.createGain();
      g.gain.value = JUMP_LAND_GAIN;
      src.connect(g);
      g.connect(sfxGain);
      try {
        src.start(ctx.currentTime + 0.01);
      } catch {
        return;
      }
      slideSrc = src;
      slideGain = g;
    }

    function setSlideLoop(on) {
      const want = Boolean(on);
      if (want) {
        slideWanted = true;
        if (slideSrc || slideLoading || muted || !sfx.slide) return;
        slideLoading = true;
        resume()
          .then(function () {
            return fetchBuffer(sfx.slide);
          })
          .then(function (buffer) {
            slideLoading = false;
            if (!slideWanted || slideSrc) return;
            startSlideLoop(buffer);
          })
          .catch(function () {
            slideLoading = false;
          });
        return;
      }
      stopSlideLoop();
    }

    function songPack(index) {
      return music[MUSIC_IDS[index]] || {};
    }

    function preloadSong(index) {
      const pack = songPack(index);
      return Promise.all(
        MUSIC_LAYERS.map(function (key) {
          return fetchBuffer(pack[key]);
        })
      );
    }

    function notifySongChange() {
      songListeners.forEach(function (fn) {
        fn(songIndex);
      });
    }

    function stopSources() {
      ignoreMusicEnded = true;
      MUSIC_LAYERS.forEach(function (key) {
        if (!sources[key]) return;
        sources[key].onended = null;
        try {
          sources[key].stop();
        } catch {
          // ignore
        }
        try {
          sources[key].disconnect();
        } catch {
          // ignore
        }
        sources[key] = null;
      });
      musicPlaying = false;
    }

    function watchLayerKey() {
      if (sources[currentIntensity]) return currentIntensity;
      for (let i = 0; i < MUSIC_LAYERS.length; i += 1) {
        const key = MUSIC_LAYERS[i];
        if (sources[key]) return key;
      }
      return null;
    }

    function setLayerGains(intensity, fadeMs, immediate) {
      if (!ctx) return;
      const now = ctx.currentTime;
      const fadeSec = (fadeMs || 0) / 1000;
      MUSIC_LAYERS.forEach(function (key) {
        const target = key === intensity ? 1 : 0;
        layerGains[key].gain.cancelScheduledValues(now);
        if (immediate || fadeSec <= 0) {
          layerGains[key].gain.setValueAtTime(target, now);
        } else {
          layerGains[key].gain.setValueAtTime(layerGains[key].gain.value, now);
          layerGains[key].gain.linearRampToValueAtTime(target, now + fadeSec);
        }
      });
      currentIntensity = intensity;
    }

    function intensityForCleared(cleared) {
      if (cleared >= 3) return "main";
      if (cleared >= 2) return "2";
      return "1";
    }

    function startSources(playToken, playIndex) {
      if (!ctx) return false;
      stopSources();
      ignoreMusicEnded = false;
      const when = ctx.currentTime + 0.02;
      let started = false;
      MUSIC_LAYERS.forEach(function (key) {
        if (!buffers[key]) return;
        const src = ctx.createBufferSource();
        src.buffer = buffers[key];
        src.loop = false;
        src.connect(layerGains[key]);
        src.start(when);
        sources[key] = src;
        started = true;
      });
      musicPlaying = started;
      const watch = watchLayerKey();
      if (watch && sources[watch]) {
        sources[watch].onended = function () {
          if (ignoreMusicEnded) return;
          if (musicPlayToken !== playToken) return;
          playSongAtIndex((playIndex + 1) % MUSIC_IDS.length, true);
        };
      }
      return started;
    }

    function playSongAtIndex(index, keepIntensity) {
      unlock();
      const token = (musicPlayToken += 1);
      songIndex = index;
      const intensity = keepIntensity ? currentIntensity : "1";
      stopSources();
      return resume()
        .then(function () {
          return preloadSong(index);
        })
        .then(function (loaded) {
          if (token !== musicPlayToken) return;
          MUSIC_LAYERS.forEach(function (key, i) {
            buffers[key] = loaded[i];
          });
          setLayerGains(intensity, 0, true);
          if (startSources(token, index)) notifySongChange();
          preloadSong((index + 1) % MUSIC_IDS.length);
        });
    }

    function startRunMusic() {
      holdMain = false;
      const next =
        songIndex < 0
          ? Math.floor(Math.random() * MUSIC_IDS.length)
          : (songIndex + 1) % MUSIC_IDS.length;
      return playSongAtIndex(next, false);
    }

    function setIntensity(cleared) {
      if (!musicPlaying) return;
      setLayerGains(intensityForCleared(cleared), MUSIC_FADE_MS, false);
    }

    function retreatToOne() {
      if (!musicPlaying || holdMain) return;
      setLayerGains("1", MUSIC_FADE_MS, false);
    }

    function keepMain() {
      holdMain = true;
    }

    function notifyMute() {
      muteListeners.forEach(function (fn) {
        fn(muted);
      });
    }

    function applyMasterGain() {
      resume().then(function () {
        setGainNow(masterGain, masterOutput());
      });
    }

    function setMuted(next) {
      muted = Boolean(next);
      try {
        localStorage.setItem(MUTE_KEY, muted ? "1" : "0");
      } catch {
        // ignore
      }
      applyMasterGain();
      notifyMute();
    }

    function setVolume(next) {
      volume = clampVolume(next);
      try {
        localStorage.setItem(VOLUME_KEY, String(volume));
      } catch {
        // ignore
      }
      if (muted) {
        setMuted(false);
        return;
      }
      applyMasterGain();
    }

    function tickSteps(running, onGround, ducking, time, skipOnce) {
      if (skipOnce || !running || !onGround || ducking) {
        lastStepBucket = -1;
        return;
      }
      const bucket = Math.floor(time * 14) % 6;
      if (bucket !== lastStepBucket && (bucket === 0 || bucket === 3)) {
        playStep();
      }
      lastStepBucket = bucket;
    }

    return {
      unlock: unlock,
      playSfx: playSfx,
      playClick: playClick,
      playGain: playGain,
      playCharSfx: playCharSfx,
      startRunMusic: startRunMusic,
      setIntensity: setIntensity,
      retreatToOne: retreatToOne,
      keepMain: keepMain,
      isMuted: function () {
        return muted;
      },
      getVolume: function () {
        return volume;
      },
      setMuted: setMuted,
      setVolume: setVolume,
      toggleMute: function () {
        setMuted(!muted);
      },
      onMuteChange: function (fn) {
        muteListeners.push(fn);
      },
      onSongChange: function (fn) {
        songListeners.push(fn);
      },
      tickSteps: tickSteps,
      setSlideLoop: setSlideLoop,
      getIntensity: function () {
        return currentIntensity;
      },
      isMusicPlaying: function () {
        return musicPlaying;
      },
      getSongIndex: function () {
        return songIndex;
      },
    };
  }

  function charDef(id) {
    return CHARACTERS.find(function (ch) { return ch.id === id; }) || CHARACTERS[0];
  }

  function charMetrics(id) {
    return CHAR_METRICS[id] || CHAR_METRICS.mars;
  }

  function qs(root, sel) {
    return root.querySelector(sel);
  }

  function monthKey(date) {
    return date.toLocaleDateString("en-CA", { timeZone: MONTH_TZ }).slice(0, 7);
  }

  function roundExpirySuffix() {
    return " Codes last 7 days after you claim.";
  }

  function claimedExpiryLine(rec) {
    const label = rec && rec.expires_at_label;
    if (!label) return "";
    if (codesAreSpent(rec)) return " Your codes expired " + label + ".";
    return " Your codes expire " + label + ".";
  }

  function codesAreSpent(rec) {
    if (rec && rec.codes_expired === true) return true;
    const iso = rec && rec.expires_at;
    if (!iso) return false;
    const ms = Date.parse(iso);
    return Number.isFinite(ms) && Date.now() >= ms;
  }

  function escapeHtml(s) {
    return String(s || "")
      .replace(/&/g, "&amp;")
      .replace(/</g, "&lt;")
      .replace(/>/g, "&gt;")
      .replace(/"/g, "&quot;");
  }

  function cookieId() {
    try {
      let id = localStorage.getItem(COOKIE_KEY);
      if (!id || id.length < 12) {
        id = crypto.randomUUID();
        localStorage.setItem(COOKIE_KEY, id);
      }
      return id;
    } catch {
      return "anon-" + Math.random().toString(36).slice(2, 12);
    }
  }

  function readSavedChar() {
    try {
      let id = localStorage.getItem(CHAR_KEY);
      if (CHAR_ALIAS[id]) id = CHAR_ALIAS[id];
      if (CHARACTERS.some(function (ch) { return ch.id === id; })) return id;
    } catch {
      // ignore
    }
    return "mars";
  }

  function saveChar(id) {
    try {
      localStorage.setItem(CHAR_KEY, id);
    } catch {
      // ignore
    }
  }

  function loadImage(src) {
    return new Promise((resolve) => {
      if (!src) {
        resolve(null);
        return;
      }
      const img = new Image();
      img.onload = function () {
        resolve(img);
      };
      img.onerror = function () {
        resolve(null);
      };
      img.src = src;
    });
  }

  function goldSignCopy(img) {
    if (!img) return null;
    try {
      const canvas = document.createElement("canvas");
      canvas.width = img.width;
      canvas.height = img.height;
      const gx = canvas.getContext("2d");
      if (!gx) return null;
      gx.imageSmoothingEnabled = false;
      gx.drawImage(img, 0, 0);
      const data = gx.getImageData(0, 0, canvas.width, canvas.height);
      const px = data.data;
      for (let i = 0; i < px.length; i += 4) {
        if (px[i + 3] < 16) continue;
        const r = px[i];
        const gr = px[i + 1];
        const b = px[i + 2];
        const max = Math.max(r, gr, b);
        const min = Math.min(r, gr, b);
        if (max <= 80 || max - min <= 40) continue;
        const lum = max / 255;
        px[i] = Math.round(SIGN_GOLD[0] * lum);
        px[i + 1] = Math.round(SIGN_GOLD[1] * lum);
        px[i + 2] = Math.round(SIGN_GOLD[2] * lum);
      }
      gx.putImageData(data, 0, 0);
      return canvas;
    } catch (err) {
      return null;
    }
  }

  function percentForStage(cleared) {
    return Math.min(40, Math.max(0, cleared) * 10);
  }

  function unlockedList(percent) {
    return PERCENTS.filter(function (p) {
      return p <= percent;
    });
  }

  function nextLocked(percent) {
    return PERCENTS.find(function (p) {
      return p > percent;
    }) || null;
  }

  function codesFromRemote(rec) {
    const codes = {};
    if (!rec) return codes;
    if (rec.codes && typeof rec.codes === "object") {
      Object.keys(rec.codes).forEach(function (key) {
        if (rec.codes[key]) codes[Number(key)] = String(rec.codes[key]);
      });
    }
    if (rec.code && rec.percent && !codes[rec.percent]) {
      codes[rec.percent] = String(rec.code);
    }
    return codes;
  }

  function codesListHtml(codes) {
    const percents = Object.keys(codes)
      .map(Number)
      .sort(function (a, b) {
        return a - b;
      });
    if (!percents.length) return "";
    return (
      '<ul class="ovani-dg__codes">' +
      percents
        .map(function (p) {
          return (
            "<li>" +
            p +
            '% — <strong class="ovani-dg__code">' +
            escapeHtml(codes[p]) +
            "</strong></li>"
          );
        })
        .join("") +
      "</ul>"
    );
  }

  function shopCode(codes, rec) {
    const percents = Object.keys(codes)
      .map(Number)
      .sort(function (a, b) {
        return a - b;
      });
    const top = percents.length ? percents[percents.length - 1] : Number(rec && rec.percent) || 0;
    return codes[top] || (rec && rec.code) || "";
  }

  function localKey(month) {
    return "ovani-runner-local-" + month;
  }

  function readLocal(month) {
    try {
      return JSON.parse(localStorage.getItem(localKey(month)) || "null");
    } catch {
      return null;
    }
  }

  function writeLocal(month, data) {
    try {
      localStorage.setItem(localKey(month), JSON.stringify(data));
    } catch {
      // ignore
    }
  }

  function readHighscore() {
    try {
      return Math.max(0, Math.floor(Number(localStorage.getItem(HIGHSCORE_KEY)) || 0));
    } catch {
      return 0;
    }
  }

  function writeHighscore(n) {
    try {
      localStorage.setItem(HIGHSCORE_KEY, String(Math.max(0, Math.floor(n))));
    } catch {
      // ignore
    }
  }

  function init(root) {
    const canvas = qs(root, "[data-ovani-dg-canvas]");
    if (!canvas) return;
    const ctx = canvas.getContext("2d");
    const overlay = qs(root, "[data-ovani-dg-overlay]");
    const titleEl = qs(root, "[data-ovani-dg-overlay-title]");
    const bodyEl = qs(root, "[data-ovani-dg-overlay-body]");
    const actionsEl = qs(root, "[data-ovani-dg-actions]");
    const formEl = qs(root, "[data-ovani-dg-claim]");
    const claimSubmitEl = formEl ? formEl.querySelector('button[type="submit"]') : null;
    const emailEl = qs(root, "[data-ovani-dg-email]");
    const statusEl = qs(root, "[data-ovani-dg-status]");
    const hudMarker = qs(root, "[data-ovani-dg-progress-marker]");
    const hudProgress = qs(root, "[data-ovani-dg-progress]");
    const hudScore = qs(root, "[data-ovani-dg-score]");
    const hudScoreNow = qs(root, "[data-ovani-dg-score-now]");
    const hudScoreBest = qs(root, "[data-ovani-dg-score-best]");
    const workerUrl = String(root.getAttribute("data-worker-url") || "").replace(/\/$/, "");
    const realCodes = root.getAttribute("data-real-codes") === "true";
    const presetEmail = String(root.getAttribute("data-customer-email") || "");
    const artEl = qs(root, "[data-ovani-dg-art]");
    let art = { chars: {}, city: {}, tiles: {}, obstacles: {}, signs: {}, fx: {}, sfx: {}, music: {} };
    try {
      art = JSON.parse(artEl && artEl.textContent ? artEl.textContent : "{}");
    } catch {
      art = { chars: {}, city: {}, tiles: {}, obstacles: {}, signs: {}, fx: {}, sfx: {}, music: {} };
    }
    const audio = createRunnerAudio(art);
    if (typeof location !== "undefined" && /(?:\?|&)ovaniDgDebug=1(?:&|$)/.test(location.search)) {
      window.__ovaniDiscountGameAudio = audio;
    }
    const muteBtn = qs(root, "[data-ovani-dg-mute]");
    const muteLabel = qs(root, ".ovani-dg__mute-label");
    const volumeInput = qs(root, "[data-ovani-dg-volume]");
    const audioDock = qs(root, "[data-ovani-dg-audio]");
    const nowPlayingEl = qs(root, "[data-ovani-dg-nowplaying]");
    const nowPlayingTrack = qs(root, "[data-ovani-dg-nowplaying-track]");
    const nowPlayingArt = qs(root, "[data-ovani-dg-nowplaying-art]");
    const duckBtn = qs(root, "[data-ovani-dg-duck]");
    const jumpBtn = qs(root, "[data-ovani-dg-jump]");
    const id = cookieId();
    const month = monthKey(new Date());

    const images = {
      chars: {},
      city: {},
      tiles: {},
      obstacles: {},
      signs: {},
      signsGold: {},
      fx: {},
    };
    const duckKeys = new Set();
    const state = {
      screen: "menu",
      mode: "play",
      running: false,
      dead: false,
      time: 0,
      distance: 0,
      stage: 1,
      cleared: 0,
      crashTime: 0,
      character: readSavedChar(),
      player: { x: 84, y: 0, vy: 0, onGround: true, frame: 0, ducking: false },
      obstacles: [],
      wantDuck: false,
      duckHeld: false,
      patternIndex: 0,
      sawHang: false,
      levelUp: 0,
      spawnHold: 0,
      bonusPhase: "off",
      celebrateTime: 0,
      celebrateBurst: 0,
      scoreStartDistance: 0,
      bonusScore: 0,
      submittedComplete: false,
      runToken: "",
      runStartedAt: 0,
      ended: false,
      remote: null,
      fx: [],
      landSfxPlayed: false,
      skipNextStep: false,
    };

    function groundY() {
      return WORLD_H - GROUND_H;
    }

    function speed() {
      return SPEEDS[Math.min(STAGE_COUNT - 1, Math.max(0, state.stage - 1))];
    }

    function spawnStage() {
      return state.bonusPhase === "score" ? BONUS_SPAWN_STAGE : state.stage;
    }

    function checkpointDistance(n) {
      let d = 0;
      for (let i = 0; i < n && i < STAGE_COUNT; i += 1) {
        d += STAGE_LENGTHS[i];
      }
      return d;
    }

    function stageAtDistance(d) {
      let acc = 0;
      for (let i = 0; i < STAGE_COUNT; i += 1) {
        acc += STAGE_LENGTHS[i];
        if (d < acc) return i + 1;
      }
      return STAGE_COUNT;
    }

    function nextBoundaryDistance() {
      if (state.bonusPhase !== "off") return null;
      if (state.stage > STAGE_COUNT) return null;
      return checkpointDistance(state.stage);
    }

    function spawnSpeed() {
      const v = speed();
      const boundary = nextBoundaryDistance();
      if (boundary == null) return v;
      const travel = WORLD_W + 28 - state.player.x;
      const span = LAND_OFFSET.base + LAND_OFFSET.per * v;
      if (state.distance + travel + span <= boundary) return v;
      return SPEEDS[Math.min(STAGE_COUNT - 1, state.stage)] || v;
    }

    function currentChar() {
      return charDef(state.character);
    }

    function metrics() {
      return charMetrics(state.character);
    }

    function charDraw() {
      return metrics().draw;
    }

    function charFrame() {
      return metrics().frame;
    }

    function charDuckDraw() {
      return metrics().duckDraw;
    }

    function setHudMarkerChar() {
      if (!hudMarker) return;
      const src = art.chars && art.chars[state.character] && art.chars[state.character].idle;
      hudMarker.style.backgroundImage = src ? "url(\"" + src + "\")" : "none";
    }

    function setHud() {
      const pct = Math.max(0, Math.min(1, state.time / TOTAL_SECONDS));
      const pctCss = (pct * 100).toFixed(2) + "%";
      if (hudMarker) hudMarker.style.left = pctCss;
      if (hudProgress) {
        hudProgress.setAttribute("aria-label", "Run progress " + Math.round(pct * 100) + " percent");
      }
      const showScore = state.bonusPhase === "score" || (state.dead && state.cleared >= STAGE_COUNT);
      if (hudScore) hudScore.hidden = !showScore;
      if (showScore) {
        const best = Math.max(readHighscore(), state.bonusScore);
        if (hudScoreNow) hudScoreNow.textContent = String(state.bonusScore);
        if (hudScoreBest) hudScoreBest.textContent = "Best " + best;
      }
    }

    function triggerLevelUp() {
      state.levelUp = LEVEL_UP_SECONDS;
      const p = state.player;
      spawnFx("particles", p.x + charDraw() / 2, p.y + 10, 0.45);
      setHud();
      if (state.cleared > 0 && state.cleared < STAGE_COUNT) {
        audio.playGain();
        audio.setIntensity(state.cleared);
      }
    }

    function setOverlayOpen(open) {
      overlay.hidden = !open;
      overlay.classList.toggle("is-scrollable", Boolean(open && formEl && !formEl.hidden));
    }

    function uiSound(kind, gainValue) {
      if (kind === "back") audio.playSfx("back");
      else if (kind !== "none") audio.playClick(gainValue);
    }

    function wrapUiClick(onClick, kind, gainValue) {
      return function (event) {
        uiSound(kind, gainValue);
        onClick(event);
      };
    }

    function showOverlay(title, body, buttons, footnote) {
      titleEl.textContent = title;
      bodyEl.innerHTML = body;
      actionsEl.innerHTML = "";
      formEl.hidden = true;
      (buttons || []).forEach(function (btn, i) {
        const el = document.createElement("button");
        el.type = "button";
        el.className = "ovani-dg__btn" + (btn.ghost ? " ovani-dg__btn--ghost" : "");
        el.textContent = btn.label;
        if (btn.primary || i === 0) el.setAttribute("data-ovani-dg-primary", "true");
        const kind = btn.sound || (btn.label === "Back" ? "back" : "click");
        el.addEventListener("click", wrapUiClick(btn.onClick, kind, btn.soundGain));
        actionsEl.appendChild(el);
      });
      if (footnote) {
        const note = document.createElement("p");
        note.className = "ovani-dg__overlay-note";
        note.textContent = footnote;
        actionsEl.appendChild(note);
      }
      appendOverlayScore();
      setOverlayOpen(true);
    }

    function hideOverlay() {
      setOverlayOpen(false);
    }

    function spawnHitsCheckpoint() {
      const nextD = nextBoundaryDistance();
      if (nextD == null) return false;
      const v = speed();
      const travel = WORLD_W + 28 - state.player.x;
      const arriveDist = state.distance + travel;
      const lead = v * CHECKPOINT_LEAD;
      const clear = v * SPEED_UP_CLEAR;
      return arriveDist > nextD - lead && arriveDist < nextD + clear;
    }

    function status(msg) {
      if (statusEl) statusEl.textContent = msg || "";
    }

    async function api(path, body) {
      if (!workerUrl || !realCodes) return null;
      const res = await fetch(workerUrl + path, {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify(body || {}),
      });
      const data = await res.json().catch(function () {
        return {};
      });
      if (!res.ok) {
        const err = new Error(data.error || "Request failed");
        err.payload = data;
        throw err;
      }
      return data;
    }

    async function refreshStatus() {
      if (!realCodes || !workerUrl) {
        state.remote = readLocal(month);
        return state.remote;
      }
      try {
        const data = await api("/game/status", { cookie_id: id, email: presetEmail || undefined });
        state.remote = data;
        return data;
      } catch (err) {
        status(err.message);
        return null;
      }
    }

    function applyLocalUnlock(cleared) {
      const rec = readLocal(month) || {};
      const codes = codesFromRemote(rec);
      const pct = percentForStage(cleared);
      rec.percent = Math.max(Number(rec.percent) || 0, pct);
      rec.stage = Math.max(Number(rec.stage) || 0, cleared);
      rec.unlocked = unlockedList(rec.percent);
      rec.codes = codes;
      rec.can_claim = rec.unlocked.some(function (p) {
        return !codes[p];
      });
      rec.can_play = true;
      writeLocal(month, rec);
      state.remote = rec;
      return rec;
    }

    function playButtons(ghost) {
      return [{
        label: ghost ? "Try again" : "Play",
        ghost: Boolean(ghost),
        primary: true,
        onClick: showCharacterPick,
        soundGain: ghost ? MINUS_4_DB : undefined,
      }];
    }

    function syncPad() {
      root.classList.toggle("ovani-dg--no-duck", Boolean(currentChar().noDuck));
    }

    function spawnFx(kind, x, y, life) {
      const img = images.fx[kind];
      if (!img) return;
      const fw = 48;
      const fh = 48;
      state.fx.push({
        kind: kind,
        x: x,
        y: y,
        t: 0,
        life: life || 0.38,
        fw: fw,
        fh: fh,
        frames: Math.max(1, Math.floor(img.width / fw)),
      });
    }

    function shopButton(codes, rec) {
      const code = shopCode(codes, rec);
      if (!code) return null;
      const percents = Object.keys(codes)
        .map(Number)
        .sort(function (a, b) {
          return a - b;
        });
      const top = percents.length ? percents[percents.length - 1] : Number(rec && rec.percent) || 0;
      return {
        label: "Shop with " + top + "%",
        onClick: function () {
          window.location.href = "/discount/" + encodeURIComponent(code);
        },
      };
    }

    function resetWorld() {
      state.time = 0;
      state.distance = 0;
      state.stage = 1;
      state.cleared = 0;
      state.dead = false;
      state.ended = false;
      state.crashTime = 0;
      state.running = true;
      state.player.y = groundY() - charDraw();
      state.player.vy = 0;
      state.player.onGround = true;
      state.player.frame = 0;
      state.player.ducking = false;
      state.obstacles = [];
      state.patternIndex = 0;
      state.sawHang = false;
      state.levelUp = 0;
      state.spawnHold = 0;
      state.bonusPhase = "off";
      state.celebrateTime = 0;
      state.celebrateBurst = 0;
      state.scoreStartDistance = 0;
      state.bonusScore = 0;
      state.submittedComplete = false;
      state.fx = [];
      state.landSfxPlayed = false;
      state.skipNextStep = false;
      syncPad();
      setHudMarkerChar();
      setHud();
    }

    function pick(arr) {
      return arr[Math.floor(Math.random() * arr.length)];
    }

    function spawnGap() {
      const react = REACT[Math.min(STAGE_COUNT - 1, spawnStage() - 1)] || 0.5;
      return spawnSpeed() * (react + Math.random() * 0.1);
    }

    function makeObstacle(kind, x, extra) {
      const def = OBS_DEFS[kind] || OBS_DEFS.spike;
      const hang = Boolean(def.hang);
      return {
        kind: kind,
        x: x,
        w: def.w,
        h: def.h,
        hang: hang,
        y: hang ? groundY() - DUCK_CLEAR - def.h : groundY() - def.h,
        duckHint: Boolean(extra && extra.duckHint),
      };
    }

    function spawnPattern(startX) {
      const stage = spawnStage();
      const list = PATTERNS[stage] || PATTERNS[1];
      const tokens = list[state.patternIndex % list.length];
      state.patternIndex += 1;
      const spawnV = spawnSpeed();
      tokens.forEach(function (token) {
        const parts = String(token).split("@");
        const role = parts[0];
        const extra = parts[1];
        let offset = 0;
        if (extra === "land") offset = Math.round(LAND_OFFSET.base + spawnV * LAND_OFFSET.per);
        else if (extra === "rise") offset = Math.round(RISE_OFFSET.base + spawnV * RISE_OFFSET.per);
        else if (extra) offset = Number(extra) || 0;
        let kind;
        if (role === "hang") {
          kind = pick(HANG_POOL[stage] || HANG_POOL[2]);
          const firstHang = !state.sawHang;
          if (firstHang) state.sawHang = true;
          state.obstacles.push(makeObstacle(kind, startX + offset, { duckHint: firstHang }));
        } else {
          const pool = GROUND_POOL[stage] || GROUND_POOL[1];
          kind = pick(pool);
          state.obstacles.push(makeObstacle(kind, startX + offset));
        }
      });
    }

    function refreshDuck() {
      if (currentChar().noDuck) {
        state.wantDuck = false;
        state.player.ducking = false;
        return;
      }
      state.wantDuck = duckKeys.size > 0 || state.duckHeld;
      const p = state.player;
      p.ducking = Boolean(state.running && !state.dead && state.wantDuck && p.onGround);
    }

    function jump() {
      if (!state.running || state.dead) return;
      if (state.player.onGround) {
        state.player.vy = JUMP_V;
        state.player.onGround = false;
        state.player.ducking = false;
        state.landSfxPlayed = false;
        spawnFx("smoke", state.player.x + charDraw() / 2, groundY() - 8, 0.32);
        audio.playCharSfx(state.character, "Jump", JUMP_LAND_GAIN);
      }
    }

    function duckDrawX(p) {
      return p.x + (charDraw() - charDuckDraw()) / 2;
    }

    function duckDrawY(p) {
      return p.y + charDraw() - charDuckDraw();
    }

    function playerBox() {
      const p = state.player;
      const draw = charDraw();
      if (p.ducking) {
        const duck = charDuckDraw();
        const w = Math.round(duck * 30 / 62);
        const h = Math.round(duck * 18 / 62);
        const foot = Math.round(duck * 4 / 62);
        return {
          x: duckDrawX(p) + Math.round((duck - w) / 2),
          y: duckDrawY(p) + duck - h - foot,
          w: w,
          h: h,
        };
      }
      const w = Math.round(draw * 32 / 96);
      const h = Math.round(draw * 58 / 96);
      return {
        x: p.x + Math.round((draw - w) / 2),
        y: p.y + draw - h,
        w: w,
        h: h,
      };
    }

    function hitObstacle() {
      const pb = playerBox();
      for (let i = 0; i < state.obstacles.length; i += 1) {
        const o = state.obstacles[i];
        const insetBottom = o.hang ? 2 : 4;
        if (pb.x < o.x + o.w - 6 && pb.x + pb.w > o.x + 6 && pb.y < o.y + o.h - insetBottom && pb.y + pb.h > o.y + 4) {
          return o;
        }
      }
      return null;
    }

    function blit(img, sx, sy, sw, sh, dx, dy, dw, dh) {
      if (!img) return false;
      ctx.drawImage(img, sx, sy, sw, sh, dx, dy, dw, dh);
      return true;
    }

    const outlineScratch = document.createElement("canvas");
    const outlineCtx = outlineScratch.getContext("2d");
    const duckOutlineScratch = document.createElement("canvas");
    const duckOutlineCtx = duckOutlineScratch.getContext("2d");

    function blitDuckOutlined(img, sx, sy, sw, sh, dx, dy, dw, dh) {
      if (!img) return false;
      const pad = 1;
      const cw = sw + pad * 2;
      const ch = sh + pad * 2;
      if (duckOutlineScratch.width !== cw || duckOutlineScratch.height !== ch) {
        duckOutlineScratch.width = cw;
        duckOutlineScratch.height = ch;
        duckOutlineCtx.imageSmoothingEnabled = false;
      } else {
        duckOutlineCtx.clearRect(0, 0, cw, ch);
      }
      duckOutlineCtx.save();
      duckOutlineCtx.filter = "brightness(0)";
      duckOutlineCtx.drawImage(img, sx, sy, sw, sh, pad - 1, pad, sw, sh);
      duckOutlineCtx.drawImage(img, sx, sy, sw, sh, pad + 1, pad, sw, sh);
      duckOutlineCtx.drawImage(img, sx, sy, sw, sh, pad, pad - 1, sw, sh);
      duckOutlineCtx.drawImage(img, sx, sy, sw, sh, pad, pad + 1, sw, sh);
      duckOutlineCtx.restore();
      duckOutlineCtx.drawImage(img, sx, sy, sw, sh, pad, pad, sw, sh);
      const destPad = pad * (dw / sw);
      ctx.drawImage(duckOutlineScratch, 0, 0, cw, ch, dx - destPad, dy - destPad, dw + destPad * 2, dh + destPad * 2);
      return true;
    }

    function blitOutlined(img, dx, dy, dw, dh) {
      if (!img) return false;
      const pad = 1;
      const cw = Math.max(1, Math.ceil(dw) + pad * 2);
      const ch = Math.max(1, Math.ceil(dh) + pad * 2);
      if (outlineScratch.width !== cw || outlineScratch.height !== ch) {
        outlineScratch.width = cw;
        outlineScratch.height = ch;
        outlineCtx.imageSmoothingEnabled = false;
      } else {
        outlineCtx.clearRect(0, 0, cw, ch);
      }
      outlineCtx.save();
      outlineCtx.filter = "brightness(0) invert(1)";
      outlineCtx.drawImage(img, 0, 0, img.width, img.height, pad - 1, pad, dw, dh);
      outlineCtx.drawImage(img, 0, 0, img.width, img.height, pad + 1, pad, dw, dh);
      outlineCtx.drawImage(img, 0, 0, img.width, img.height, pad, pad - 1, dw, dh);
      outlineCtx.drawImage(img, 0, 0, img.width, img.height, pad, pad + 1, dw, dh);
      outlineCtx.restore();
      outlineCtx.globalCompositeOperation = "source-in";
      outlineCtx.fillStyle = "#22d3ee";
      outlineCtx.fillRect(0, 0, cw, ch);
      outlineCtx.globalCompositeOperation = "source-over";
      ctx.drawImage(outlineScratch, dx - pad, dy - pad);
      ctx.drawImage(img, 0, 0, img.width, img.height, dx, dy, dw, dh);
      return true;
    }

    function strokeObstacleBox(x, y, w, h) {
      ctx.strokeStyle = "#22d3ee";
      ctx.lineWidth = 2;
      ctx.strokeRect(x + 1, y + 1, Math.max(1, w - 2), Math.max(1, h - 2));
    }

    function drawParallax(img, scroll, factor) {
      if (!img) return 0;
      const scale = WORLD_H / img.height;
      const dw = img.width * scale;
      const x = -((scroll * factor) % dw);
      const drawW = Math.ceil(dw) + 1;
      for (let px = x; px < WORLD_W + dw; px += dw) {
        ctx.drawImage(img, 0, 0, img.width, img.height, px, 0, drawW, WORLD_H);
      }
      return dw;
    }

    function signGoldOn() {
      if (state.levelUp <= 0) return false;
      const elapsed = LEVEL_UP_SECONDS - state.levelUp;
      const phase = (elapsed / LEVEL_UP_SECONDS) * SIGN_GOLD_BLINKS;
      return phase % 1 < 0.5;
    }

    function drawTiledSigns(layerImg, scroll, factor, placements) {
      if (!layerImg || !placements || !placements.length) return;
      const scale = WORLD_H / layerImg.height;
      const tileW = layerImg.width * scale;
      const goldOn = signGoldOn();
      let origin = -((scroll * factor) % tileW);
      for (let tile = origin; tile < WORLD_W + tileW; tile += tileW) {
        placements.forEach(function (p) {
          const sign = goldOn && images.signsGold[p.kind]
            ? images.signsGold[p.kind]
            : images.signs[p.kind];
          if (!sign) return;
          ctx.drawImage(
            sign,
            0,
            0,
            sign.width,
            sign.height,
            tile + p.sx * scale,
            p.sy * scale,
            sign.width * scale,
            sign.height * scale
          );
        });
      }
    }

    function drawGround(scroll) {
      const tile = GROUND_H;
      const top = images.tiles.top;
      const fill = images.tiles.fill;
      const start = -((scroll) % tile);
      for (let x = start; x < WORLD_W + tile; x += tile) {
        if (!blit(top, 0, 0, top ? top.width : 32, top ? top.height : 32, x, groundY(), tile, tile)) {
          ctx.fillStyle = "#1a1630";
          ctx.fillRect(x, groundY(), tile, GROUND_H);
          ctx.fillStyle = "#22d3ee";
          ctx.fillRect(x, groundY(), tile, 3);
        }
        blit(fill, 0, 0, fill ? fill.width : 32, fill ? fill.height : 32, x, groundY() + 24, tile, tile);
      }
    }

    function drawStreetHaze() {
      const gy = groundY();
      const hazeH = 200;
      const top = gy - hazeH;
      const fog = ctx.createLinearGradient(0, top, 0, gy);
      fog.addColorStop(0, "rgba(130, 170, 200, 0)");
      fog.addColorStop(0.35, "rgba(130, 170, 200, 0.17)");
      fog.addColorStop(0.7, "rgba(150, 190, 210, 0.40)");
      fog.addColorStop(1, "rgba(170, 210, 220, 0.72)");
      ctx.fillStyle = fog;
      ctx.fillRect(0, top, WORLD_W, hazeH);
    }

    function drawBg(scroll) {
      ctx.fillStyle = "#1a1030";
      ctx.fillRect(0, 0, WORLD_W, WORLD_H);
      drawParallax(images.city.sky, scroll, 0.08);
      drawParallax(images.city.clouds, scroll, 0.16);
      drawParallax(images.city.far, scroll, 0.32);
      drawTiledSigns(images.city.far, scroll, 0.32, FAR_SIGNS);
      drawParallax(images.city.near, scroll, 0.5);
      drawTiledSigns(images.city.near, scroll, 0.5, NEAR_SIGNS);
      drawStreetHaze();
    }

    function sheetFrames(sheet, fallback) {
      const fw = charFrame();
      if (!sheet || !sheet.width) return fallback || 1;
      return Math.max(1, Math.floor(sheet.width / fw));
    }

    function drawPlayer(p) {
      const sheets = images.chars[state.character] || {};
      const fw = charFrame();
      const draw = charDraw();
      const duck = charDuckDraw();
      let sheet = sheets.run;
      let frames = 6;
      let frame = 0;
      if (state.dead) {
        sheet = sheets.death || sheets.run;
        frames = sheetFrames(sheet, 6);
        frame = Math.min(frames - 1, Math.floor((state.crashTime / DEATH_SECONDS) * frames));
      } else if (p.ducking) {
        const dx = duckDrawX(p);
        const dy = duckDrawY(p);
        sheet = sheets.duck || sheets.run;
        frames = sheetFrames(sheet, 6);
        frame = Math.floor(state.time * 14) % frames;
        if (sheets.duck) {
          const ducked = blitDuckOutlined(sheet, frame * fw, 0, fw, fw, dx, dy, duck, duck);
          if (ducked) return;
        }
        ctx.save();
        ctx.translate(dx, dy + duck);
        ctx.scale(1, 0.55);
        const ok = blit(sheets.run, frame * fw, 0, fw, fw, 0, -duck, duck, duck);
        ctx.restore();
        if (ok) return;
        const bw = Math.round(duck * 30 / 62);
        const bh = Math.round(duck * 18 / 62);
        const foot = Math.round(duck * 4 / 62);
        ctx.fillStyle = "#22d3ee";
        ctx.fillRect(dx + Math.round((duck - bw) / 2), dy + duck - bh - foot, bw, bh);
        return;
      } else if (p.onGround) {
        sheet = sheets.run;
        frames = sheetFrames(sheet, 6);
        frame = Math.floor(state.time * 10) % frames;
      } else {
        sheet = sheets.jump || sheets.run;
        frames = sheetFrames(sheet, 4);
        if (frames <= 4) {
          frame = p.vy < 0 ? (p.vy < -400 ? 0 : 1) : p.vy < 400 ? 2 : 3;
          frame = Math.min(frames - 1, frame);
        } else if (p.vy < -400) frame = 0;
        else if (p.vy < -150) frame = 1;
        else if (p.vy < 150) frame = 2;
        else if (p.vy < 400) frame = 3;
        else if (p.vy < 600) frame = Math.min(frames - 2, 4);
        else frame = frames - 1;
      }
      const ok = blit(sheet, frame * fw, 0, fw, fw, p.x, p.y, draw, draw);
      if (!ok) {
        const bw = Math.round(draw * 32 / 96);
        const bh = Math.round(draw * 58 / 96);
        ctx.fillStyle = "#22d3ee";
        ctx.fillRect(p.x + Math.round((draw - bw) / 2), p.y + draw - bh, bw, bh);
      }
    }

    function drawObstacle(o) {
      const map = {
        spike: images.obstacles.crate,
        spike2: images.obstacles.crate2,
        vinyl: images.obstacles.barrel,
        cable: images.obstacles.flag,
        robot: images.obstacles.locker,
        headphones: images.obstacles.board,
        hangpipe: images.obstacles.pipe,
        hangflag: images.obstacles.flag,
        hangboard: images.obstacles.board,
        box: images.obstacles.box,
        box2: images.obstacles.box2,
        capsule: images.obstacles.capsule,
      };
      if (o.hang) {
        ctx.fillStyle = "rgba(34, 211, 238, 0.14)";
        ctx.fillRect(o.x, o.y, o.w, o.h);
        ctx.fillStyle = "#1affe7";
        ctx.fillRect(o.x + 3, 0, 2, o.y + 8);
        ctx.fillRect(o.x + o.w - 5, 0, 2, o.y + 8);
        ctx.fillStyle = "#22d3ee";
        ctx.fillRect(o.x, o.y + o.h - 3, o.w, 3);
      }
      const img = map[o.kind];
      if (o.kind === "hangpipe" && img) {
        const barH = Math.min(40, o.h);
        const oy = o.y + o.h - barH;
        blitOutlined(img, o.x, oy, o.w, barH);
        ctx.fillStyle = "#22305c";
        ctx.fillRect(o.x + 6, o.y, 5, o.h - barH + 2);
        ctx.fillRect(o.x + o.w - 11, o.y, 5, o.h - barH + 2);
        return;
      }
      if (o.kind === "hangboard" && img) {
        const bh = Math.min(48, o.h);
        const oy = o.y + o.h - bh;
        blitOutlined(img, o.x, oy, o.w, bh);
        ctx.fillStyle = "#5c3a1a";
        ctx.fillRect(o.x + o.w / 2 - 2, o.y, 4, o.h - bh + 2);
        return;
      }
      if (o.kind === "hangflag" && img) {
        const fh = Math.min(58, o.h);
        const oy = o.y + o.h - fh;
        blitOutlined(img, o.x, oy, o.w, fh);
        ctx.fillStyle = "#1affe7";
        ctx.fillRect(o.x + o.w / 2 - 1, 0, 2, o.y + o.h - fh + 2);
        return;
      }
      if (img && blitOutlined(img, o.x, o.y, o.w, o.h)) {
        return;
      }
      ctx.fillStyle = o.hang ? "#34d7ff" : o.kind === "vinyl" ? "#ff2ec8" : "#6b7280";
      ctx.fillRect(o.x, o.y, o.w, o.h);
      strokeObstacleBox(o.x, o.y, o.w, o.h);
    }

    function drawFx() {
      state.fx.forEach(function (fx) {
        const img = images.fx[fx.kind];
        if (!img) return;
        const frame = Math.min(fx.frames - 1, Math.floor((fx.t / fx.life) * fx.frames));
        blit(img, frame * fx.fw, 0, fx.fw, fx.fh, fx.x - fx.fw / 2, fx.y - fx.fh / 2, fx.fw, fx.fh);
      });
    }

    function updateFx(dt) {
      state.fx.forEach(function (fx) {
        fx.t += dt;
      });
      state.fx = state.fx.filter(function (fx) {
        return fx.t < fx.life;
      });
    }

    function drawCheckpoints() {
      const gy = groundY();
      ctx.save();
      ctx.imageSmoothingEnabled = true;
      for (let n = 1; n <= STAGE_COUNT; n += 1) {
        const dist = checkpointDistance(n);
        const x = state.player.x + (dist - state.distance);
        if (x < -48 || x > WORLD_W + 48) continue;
        const label = n < STAGE_COUNT ? "STAGE " + (n + 1) : "FINISH";
        ctx.fillStyle = "rgba(245, 211, 106, 0.22)";
        ctx.fillRect(x - 1, 12, 2, gy - 12);
        ctx.fillStyle = "#22d3ee";
        ctx.fillRect(x - 7, gy, 14, 5);
        ctx.fillStyle = "#f5d36a";
        ctx.fillRect(x - 5, gy + 5, 10, GROUND_H - 5);
        ctx.font = "bold 11px ui-sans-serif, sans-serif";
        ctx.textAlign = "center";
        ctx.textBaseline = "bottom";
        ctx.lineWidth = 3;
        ctx.strokeStyle = "rgba(12, 8, 20, 0.9)";
        ctx.fillStyle = "#f5d36a";
        ctx.strokeText(label, x, gy - 8);
        ctx.fillText(label, x, gy - 8);
      }
      ctx.restore();
    }

    function drawCelebrate() {
      if (state.bonusPhase !== "celebrate") return;
      const t = 1 - state.celebrateTime / CELEBRATE_SECONDS;
      let alpha = 1;
      if (t < 0.1) alpha = t / 0.1;
      else if (state.celebrateTime < 1.1) alpha = state.celebrateTime / 1.1;
      ctx.save();
      ctx.imageSmoothingEnabled = true;
      ctx.textAlign = "center";
      ctx.textBaseline = "middle";
      ctx.globalAlpha = alpha;
      ctx.lineWidth = 5;
      ctx.strokeStyle = "rgba(12, 8, 20, 0.92)";
      ctx.fillStyle = "#f5d36a";
      ctx.font = "bold 28px ui-sans-serif, sans-serif";
      ctx.strokeText("Max discount unlocked", WORLD_W / 2, 92);
      ctx.fillText("Max discount unlocked", WORLD_W / 2, 92);
      ctx.font = "bold 18px ui-sans-serif, sans-serif";
      ctx.fillStyle = "#22d3ee";
      ctx.strokeText("Now run free — go for the highscore", WORLD_W / 2, 124);
      ctx.fillText("Now run free — go for the highscore", WORLD_W / 2, 124);
      ctx.restore();
    }

    function burstCelebrateFx(dt) {
      if (state.bonusPhase !== "celebrate") return;
      state.celebrateBurst -= dt;
      if (state.celebrateBurst > 0) return;
      state.celebrateBurst = 0.22;
      const p = state.player;
      const cx = p.x + charDraw() / 2;
      spawnFx("particles", cx + (Math.random() - 0.5) * 240, 36 + Math.random() * 150, 0.55);
      spawnFx("sparks", cx + (Math.random() - 0.5) * 200, 24 + Math.random() * 130, 0.48);
    }

    function beginFinishBonus() {
      const prevPct = percentForStage(state.cleared);
      state.cleared = STAGE_COUNT;
      state.bonusPhase = "celebrate";
      state.celebrateTime = CELEBRATE_SECONDS;
      state.celebrateBurst = 0;
      state.obstacles = [];
      state.spawnHold = CELEBRATE_SECONDS;
      audio.playSfx("win");
      audio.keepMain();
      if (percentForStage(state.cleared) > prevPct) triggerLevelUp();
      else setHud();
      submitCompleteAtFinish();
    }

    function startBonusScore() {
      state.bonusPhase = "score";
      state.scoreStartDistance = state.distance;
      state.bonusScore = 0;
      state.spawnHold = 0.45;
      state.patternIndex = 0;
      setHud();
    }

    async function submitCompleteAtFinish() {
      if (state.submittedComplete) return;
      state.submittedComplete = true;
      if (realCodes && workerUrl && state.runToken) {
        try {
          const data = await api("/game/complete", {
            cookie_id: id,
            run_token: state.runToken,
            stage: state.cleared,
            duration_ms: Date.now() - state.runStartedAt,
          });
          state.remote = data;
          await refreshStatus();
        } catch (err) {
          status(err.message);
          applyLocalUnlock(state.cleared);
        }
      } else {
        applyLocalUnlock(state.cleared);
      }
    }

    function scoreLine() {
      if (!state.ended || state.cleared < STAGE_COUNT) return null;
      const best = Math.max(readHighscore(), state.bonusScore);
      const el = document.createElement("div");
      el.className = "ovani-dg__overlay-score";
      el.setAttribute("data-ovani-dg-overlay-score", "true");
      const now = document.createElement("span");
      now.className = "ovani-dg__score-now";
      now.textContent = "Score " + state.bonusScore;
      const bestEl = document.createElement("span");
      bestEl.className = "ovani-dg__score-best";
      bestEl.textContent = "Best " + best;
      el.appendChild(now);
      el.appendChild(bestEl);
      return el;
    }

    function appendOverlayScore() {
      if (!bodyEl) return;
      const existing = bodyEl.querySelector("[data-ovani-dg-overlay-score]");
      if (existing) existing.remove();
      const line = scoreLine();
      if (!line) return;
      bodyEl.insertBefore(line, bodyEl.firstChild);
    }

    function drawLevelUp() {
      if (state.levelUp <= 0) return;
      const t = 1 - state.levelUp / LEVEL_UP_SECONDS;
      const p = state.player;
      const cx = p.x + charDraw() / 2;
      const textY = p.y - 4 - t * 22;
      const textA = t < 0.14 ? t / 0.14 : Math.max(0, 1 - (t - 0.14) / 0.86);
      ctx.save();
      ctx.imageSmoothingEnabled = true;
      ctx.font = "bold 13px ui-sans-serif, sans-serif";
      ctx.textAlign = "center";
      ctx.textBaseline = "middle";
      ctx.lineWidth = 3;
      ctx.strokeStyle = "rgba(12, 8, 20, " + textA + ")";
      ctx.fillStyle = "rgba(255, 214, 80, " + textA + ")";
      ctx.strokeText("+10% OFF", cx, textY);
      ctx.fillText("+10% OFF", cx, textY);
      ctx.restore();
    }

    function drawDuckHint() {
      if (state.dead) return;
      const o = state.obstacles.find(function (obs) {
        return obs.duckHint;
      });
      if (!o) return;
      const cx = o.x + o.w / 2;
      if (cx < -60 || cx > WORLD_W + 90) return;
      const gapTop = o.y + o.h;
      const textY = gapTop + 16;
      let alpha = 1;
      if (o.x > WORLD_W - 24) {
        alpha = Math.max(0, (WORLD_W + 50 - o.x) / 74);
      }
      if (o.x + o.w < state.player.x) {
        alpha = Math.min(alpha, Math.max(0, 1 - (state.player.x - o.x - o.w) / 90));
      }
      if (alpha <= 0.02) return;
      ctx.save();
      ctx.globalAlpha = alpha;
      ctx.imageSmoothingEnabled = true;
      ctx.font = "bold 13px ui-sans-serif, sans-serif";
      ctx.textAlign = "center";
      ctx.textBaseline = "middle";
      ctx.lineWidth = 3;
      ctx.strokeStyle = "rgba(12, 8, 20, 0.92)";
      ctx.fillStyle = "#22d3ee";
      ctx.strokeText("HOLD DUCK", cx, textY);
      ctx.fillText("HOLD DUCK", cx, textY);
      const ay = textY + 12;
      ctx.beginPath();
      ctx.moveTo(cx, ay + 12);
      ctx.lineTo(cx - 8, ay);
      ctx.lineTo(cx + 8, ay);
      ctx.closePath();
      ctx.stroke();
      ctx.fill();
      ctx.restore();
    }

    function draw() {
      ctx.imageSmoothingEnabled = false;
      drawBg(state.distance);
      drawGround(state.distance);
      drawCheckpoints();
      state.obstacles.forEach(drawObstacle);
      drawDuckHint();
      drawPlayer(state.player);
      drawFx();
      drawLevelUp();
      drawCelebrate();
    }

    let lastTs = 0;
    function tick(ts) {
      if (!lastTs) lastTs = ts;
      const dt = Math.min(0.032, (ts - lastTs) / 1000);
      lastTs = ts;
      if (state.levelUp > 0) state.levelUp = Math.max(0, state.levelUp - dt);
      if (state.spawnHold > 0) state.spawnHold = Math.max(0, state.spawnHold - dt);
      updateFx(dt);
      if (state.running && !state.dead) {
        state.time += dt;
        const v = speed();
        state.distance += v * dt;
        if (state.bonusPhase === "celebrate") {
          state.celebrateTime -= dt;
          burstCelebrateFx(dt);
          if (state.celebrateTime <= 0) startBonusScore();
        } else if (state.bonusPhase === "score") {
          state.bonusScore = Math.max(0, Math.floor(state.distance - state.scoreStartDistance));
        }
        setHud();
        const stageNow = stageAtDistance(state.distance);
        if (state.bonusPhase === "off" && stageNow > state.stage) {
          state.stage = stageNow;
          state.cleared = stageNow - 1;
          triggerLevelUp();
          state.spawnHold = SPEED_UP_CLEAR;
        } else if (state.bonusPhase === "off" && state.distance >= TOTAL_DISTANCE && state.cleared < STAGE_COUNT) {
          beginFinishBonus();
        }
        if (state.running) {
          const p = state.player;
          const wasAir = !p.onGround;
          p.vy += GRAVITY * dt;
          p.y += p.vy * dt;
          const gy = groundY() - charDraw();
          if (wasAir && !state.landSfxPlayed && p.vy > 0) {
            const dist = gy - p.y;
            if (dist > 0) {
              const timeToGround = (-p.vy + Math.sqrt(p.vy * p.vy + 2 * GRAVITY * dist)) / GRAVITY;
              if (timeToGround <= LAND_SFX_LEAD) {
                audio.playSfx("land", JUMP_LAND_GAIN);
                state.landSfxPlayed = true;
                state.skipNextStep = true;
              }
            }
          }
          if (p.y >= gy) {
            p.y = gy;
            p.vy = 0;
            p.onGround = true;
            if (wasAir) {
              spawnFx("smoke", p.x + charDraw() / 2, groundY() - 8, 0.28);
              if (!state.landSfxPlayed) {
                audio.playSfx("land", JUMP_LAND_GAIN);
                state.landSfxPlayed = true;
                state.skipNextStep = true;
              }
            }
          }
          refreshDuck();
          const skipStep = state.skipNextStep;
          state.skipNextStep = false;
          audio.tickSteps(true, p.onGround, p.ducking, state.time, skipStep);
          const dx = v * dt;
          state.obstacles.forEach(function (o) {
            o.x -= dx;
          });
          state.obstacles = state.obstacles.filter(function (o) {
            return o.x + o.w > -20;
          });
          const last = state.obstacles[state.obstacles.length - 1];
          if (
            state.bonusPhase !== "celebrate" &&
            state.spawnHold <= 0 &&
            !spawnHitsCheckpoint() &&
            state.time > SPAWN_START &&
            (!last || last.x + last.w < WORLD_W - spawnGap())
          ) {
            spawnPattern(WORLD_W + 28);
          }
          const hit = state.bonusPhase === "celebrate" ? null : hitObstacle();
          if (hit) {
            state.dead = true;
            state.running = false;
            state.crashTime = 0;
            if (state.cleared < STAGE_COUNT) {
              state.cleared = Math.max(state.cleared, state.stage - 1);
            }
            spawnFx("sparks", p.x + charDraw() / 2, p.y + charDraw() / 2, 0.42);
            audio.playCharSfx(state.character, "Crash");
            audio.playSfx("fail");
            audio.retreatToOne();
          }
        }
      } else if (state.dead && !state.ended) {
        state.crashTime += dt;
        if (state.crashTime >= DEATH_SECONDS) {
          finishRun(state.cleared >= STAGE_COUNT);
        }
      }
      audio.setSlideLoop(state.running && !state.dead && state.player.ducking);
      draw();
      requestAnimationFrame(tick);
    }

    async function finishRun(won) {
      if (state.ended) return;
      state.ended = true;
      const pct = percentForStage(state.cleared);
      if (won || state.cleared >= STAGE_COUNT) {
        writeHighscore(Math.max(readHighscore(), state.bonusScore));
      }
      setHud();
      if (!state.submittedComplete) {
        if (realCodes && workerUrl && state.runToken) {
          try {
            const data = await api("/game/complete", {
              cookie_id: id,
              run_token: state.runToken,
              stage: state.cleared,
              duration_ms: Date.now() - state.runStartedAt,
            });
            state.remote = data;
            await refreshStatus();
          } catch (err) {
            status(err.message);
            applyLocalUnlock(state.cleared);
          }
        } else {
          applyLocalUnlock(state.cleared);
        }
        state.submittedComplete = true;
      }
      showRunResult(won, pct);
    }

    function showClaimOverlay(pct, won) {
      const rec = state.remote || {};
      const codes = codesFromRemote(rec);
      const next = nextLocked(pct);
      titleEl.textContent = won ? "You cleared all 4 stages" : pct >= 40 ? "40% unlocked" : "You unlocked " + pct + "% off";
      bodyEl.innerHTML = "";
      const p = document.createElement("p");
      if (!realCodes || !workerUrl) {
        const unlocked = unlockedList(pct);
        p.textContent = unlocked.length
          ? "Real coupons are off on this preview. You would claim " +
            unlocked.join("%, ") +
            "%. Flip them on in the theme editor when you want to mint codes."
          : "Real coupons are off on this preview. Reach the first checkpoint for 10% off. Flip real coupons on in the theme editor when you want to mint codes.";
      } else if (won || pct >= 40) {
        p.textContent =
          "You earned the full 10, 20, 30, and 40% set. Enter your email to get every code you do not have yet. Each works once, on its own order." +
          roundExpirySuffix(rec);
      } else if (next) {
        p.textContent =
          "Enter your email to claim every code you have earned. Keep playing for " +
          next +
          "%." +
          roundExpirySuffix(rec);
      } else {
        p.textContent =
          "Enter your email to claim every code you have earned. Each works once, on its own order." +
          roundExpirySuffix(rec);
      }
      bodyEl.appendChild(p);
      if (Object.keys(codes).length && !codesAreSpent(rec)) {
        const wrap = document.createElement("div");
        wrap.innerHTML = codesListHtml(codes);
        bodyEl.appendChild(wrap);
      }
      actionsEl.innerHTML = "";
      playButtons(true).forEach(function (btn) {
        const el = document.createElement("button");
        el.type = "button";
        el.className = "ovani-dg__btn ovani-dg__btn--ghost";
        el.textContent = "Try again";
        el.setAttribute("data-ovani-dg-primary", "true");
        el.addEventListener("click", wrapUiClick(btn.onClick, "click", MINUS_4_DB));
        actionsEl.appendChild(el);
      });
      formEl.hidden = false;
      if (presetEmail) emailEl.value = presetEmail;
      appendOverlayScore();
      setOverlayOpen(true);
    }

    function showCodesOverlay(title, lead, rec, retry) {
      const spent = codesAreSpent(rec);
      const codes = spent ? {} : codesFromRemote(rec);
      const next = nextLocked(Number(rec && rec.percent) || 0);
      const extra = next
        ? " Keep playing to unlock " + next + "%."
        : " You have the full set.";
      const buttons = spent
        ? playButtons(retry)
        : playButtons(retry).concat([shopButton(codes, rec)]).filter(Boolean);
      showOverlay(
        title,
        lead + extra + claimedExpiryLine(rec) + (spent ? "" : codesListHtml(codes)),
        buttons
      );
    }

    function showRunResult(won, pct) {
      audio.retreatToOne();
      if (!won) audio.playSfx("loss");
      const rec = state.remote || {};
      const best = Math.max(pct, Number(rec.percent) || 0);
      const canClaim = !realCodes || rec.can_claim === true;
      if (best >= 10 && canClaim) {
        showClaimOverlay(best, won);
        return;
      }
      if (!won && pct < 10) {
        const codes = codesFromRemote(rec);
        if (Object.keys(codes).length) {
          showCodesOverlay(
            "Run over",
            "You crashed before the first checkpoint this run.",
            rec,
            true
          );
          return;
        }
        showOverlay(
          "Run over",
          "You crashed before the first checkpoint. Reach it for 10% off, then 20%, 30%, and 40% at the finish.",
          playButtons(true)
        );
        return;
      }
      showCodesOverlay(
        won ? "You cleared all 4 stages" : "Run over",
        won ? "Nice run." : "You unlocked " + pct + "% this run.",
        rec,
        true
      );
    }

    function showCharacterPick() {
      audio.unlock();
      audio.playSfx("characterSelect", MINUS_4_DB);
      const saved = state.character || readSavedChar();
      titleEl.textContent = "Pick your runner";
      bodyEl.innerHTML = "";
      const lead = document.createElement("p");
      lead.textContent = "Jump crates, boxes, and capsules. Hold duck under hanging pipes.";
      bodyEl.appendChild(lead);
      const row = document.createElement("div");
      row.className = "ovani-dg__chars";
      CHARACTERS.forEach(function (ch) {
        const btn = document.createElement("button");
        btn.type = "button";
        btn.className = "ovani-dg__char" + (saved === ch.id ? " is-selected" : "");
        const sprite = document.createElement("span");
        sprite.className = "ovani-dg__char-sprite";
        const src = art.chars && art.chars[ch.id] && (art.chars[ch.id].run || art.chars[ch.id].idle);
        if (src) sprite.style.backgroundImage = "url(\"" + src + "\")";
        const label = document.createElement("span");
        label.textContent = ch.label;
        btn.appendChild(sprite);
        btn.appendChild(label);
        btn.addEventListener("click", wrapUiClick(function () {
          state.character = ch.id;
          saveChar(ch.id);
          startRun();
        }, "click"));
        row.appendChild(btn);
      });
      bodyEl.appendChild(row);
      actionsEl.innerHTML = "";
      formEl.hidden = true;
      const play = document.createElement("button");
      play.type = "button";
      play.className = "ovani-dg__btn";
      play.textContent = "Run as " + charDef(saved).label;
      play.setAttribute("data-ovani-dg-primary", "true");
      play.addEventListener("click", wrapUiClick(function () {
        state.character = saved;
        saveChar(saved);
        startRun();
      }, "click"));
      const back = document.createElement("button");
      back.type = "button";
      back.className = "ovani-dg__btn ovani-dg__btn--ghost";
      back.textContent = "Back";
      back.addEventListener("click", wrapUiClick(showMenu, "back"));
      actionsEl.appendChild(play);
      actionsEl.appendChild(back);
      setOverlayOpen(true);
    }

    function syncNowPlaying() {
      if (!nowPlayingEl) return;
      const index = audio.getSongIndex();
      if (index < 0) return;
      const id = MUSIC_IDS[index];
      const pack = (art.music && art.music[id]) || {};
      const title = pack.title || id;
      const packName = pack.pack || "";
      const line = packName ? title + " — " + packName : title;
      nowPlayingEl.href = pack.url || "#";
      nowPlayingEl.setAttribute(
        "aria-label",
        "Now playing " + line + ". Opens pack page"
      );
      if (nowPlayingArt) {
        nowPlayingArt.src = pack.image || "";
        nowPlayingArt.alt = packName || title;
      }
      nowPlayingEl.hidden = false;
      nowPlayingEl.classList.remove("is-overflowing");
      if (nowPlayingTrack) {
        nowPlayingTrack.textContent = line;
        requestAnimationFrame(function () {
          const ticker = nowPlayingTrack.parentElement;
          if (!ticker) return;
          const overflow = nowPlayingTrack.scrollWidth > ticker.clientWidth + 2;
          nowPlayingEl.classList.toggle("is-overflowing", overflow);
          if (overflow) {
            nowPlayingTrack.textContent = line + "   " + line;
          }
        });
      }
    }

    async function startRun() {
      audio.unlock();
      audio.startRunMusic();
      audio.playCharSfx(state.character, "Dash");
      state.mode = "play";
      state.runToken = "";
      if (realCodes && workerUrl) {
        try {
          const data = await api("/game/start", { cookie_id: id });
          state.runToken = data.run_token;
          state.remote = data;
        } catch (err) {
          showOverlay("Could not start", err.message, [
            { label: "Back", ghost: true, onClick: showMenu },
          ]);
          return;
        }
      } else {
        applyLocalUnlock(0);
      }
      state.runStartedAt = Date.now();
      hideOverlay();
      formEl.hidden = true;
      resetWorld();
    }

    function showMenu() {
      state.running = false;
      audio.retreatToOne();
      const rec = state.remote || {};
      const codes = codesFromRemote(rec);
      const best = Math.max(0, Number(rec.percent) || 0);
      const canClaim = Boolean(rec.can_claim) && best >= 10;
      if (canClaim) {
        showClaimOverlay(best, best >= 40);
        return;
      }
      if (Object.keys(codes).length) {
        showCodesOverlay(
          "Your discounts",
          "Each code works once, on its own order.",
          rec
        );
        return;
      }
      showOverlay(
        "Jump or duck the city clutter",
        "<p>Reach the first checkpoint for 10% off. Run farther for 20%, 30%, and 40% at the finish. After the finish you can keep running for a highscore. Play as many times as you want. Each code works once. After a crash, press Enter to try again.</p>" +
          (realCodes && workerUrl ? "<p>" + escapeHtml(roundExpirySuffix(rec).trim()) + "</p>" : ""),
        playButtons()
      );
    }

    function showClaimSuccess(data, email) {
      const codes = codesFromRemote(data);
      const masked = escapeHtml(data.email_masked || email);
      const sent = data.email_sent === true;
      const title = sent ? "Codes on the way" : "Here are your codes";
      let body = sent
        ? "<p>We emailed <strong>" +
          masked +
          "</strong>.</p><p>Each code works once, on its own order." +
          escapeHtml(claimedExpiryLine(data).trim()) +
          "</p>"
        : "<p><strong>We couldn't send email.</strong> Copy your codes below or check spam.</p>";
      if (!sent && data.email_configured === false) {
        console.warn("[ovani-discount-game] RESEND_API_KEY is not configured on the worker.");
      }
      body += codesListHtml(codes);
      const actions = playButtons(true).concat([shopButton(codes, data)]).filter(Boolean);
      if (!sent && data.email_configured) {
        actions.push({
          label: "Resend email",
          ghost: true,
          onClick: function () {
            submitClaim(email, true);
          },
        });
      }
      showOverlay(title, body, actions);
    }

    let claimInFlight = false;

    async function submitClaim(email, resend) {
      if (claimInFlight) return;
      claimInFlight = true;
      if (claimSubmitEl) claimSubmitEl.disabled = true;
      try {
        status("Sending…");
        const payload = { cookie_id: id, email: email };
        if (resend) payload.resend = true;
        const data = await api("/game/claim", payload);
        state.remote = data;
        status("");
        showClaimSuccess(data, email);
      } catch (err) {
        status(err.message);
      } finally {
        claimInFlight = false;
        if (claimSubmitEl) claimSubmitEl.disabled = false;
      }
    }

    formEl.addEventListener("submit", async function (event) {
      event.preventDefault();
      if (claimInFlight) return;
      audio.playClick();
      const email = String(emailEl.value || "").trim();
      if (!email) return;
      const rec = state.remote || {};
      const best = Math.max(Number(rec.percent) || 0, percentForStage(state.cleared));
      if (!realCodes || !workerUrl) {
        showOverlay(
          "Preview codes",
          "Real coupons are turned off. When you flip them on, this email step will mint " +
            (unlockedList(best).length ? unlockedList(best).join("%, ") + "%" : "the discounts you have earned") +
            ". Play as many times as you want.",
          playButtons()
        );
        return;
      }
      await submitClaim(email, false);
    });

    function isTypingTarget(el) {
      if (!el) return false;
      const tag = el.tagName;
      return tag === "INPUT" || tag === "TEXTAREA" || el.isContentEditable;
    }

    function onKeyDown(event) {
      if (isTypingTarget(event.target)) return;
      if (event.code === "Enter") {
        if (!overlay.hidden) {
          event.preventDefault();
          const primary = actionsEl.querySelector("[data-ovani-dg-primary]") || actionsEl.querySelector(".ovani-dg__btn");
          if (primary) primary.click();
        }
        return;
      }
      const jumpKey = event.code === "Space" || event.code === "ArrowUp" || event.code === "KeyW";
      const duckKey = event.code === "ArrowDown" || event.code === "KeyS";
      if ((jumpKey || duckKey) && overlay.hidden) event.preventDefault();
      if (jumpKey) {
        if (event.repeat) return;
        jump();
        return;
      }
      if (duckKey) {
        if (currentChar().noDuck) return;
        duckKeys.add(event.code);
        refreshDuck();
      }
    }

    function onKeyUp(event) {
      if (event.code === "ArrowDown" || event.code === "KeyS") {
        duckKeys.delete(event.code);
        refreshDuck();
      }
    }

    function bindHold(el, down, up) {
      if (!el) return;
      el.addEventListener("pointerdown", function (event) {
        event.preventDefault();
        event.stopPropagation();
        try {
          el.setPointerCapture(event.pointerId);
        } catch {
          // ignore
        }
        down();
      });
      el.addEventListener("pointerup", function (event) {
        event.preventDefault();
        up();
      });
      el.addEventListener("pointercancel", up);
    }

    canvas.addEventListener("pointerdown", function (event) {
      if (!overlay.hidden) return;
      event.preventDefault();
      jump();
    });
    bindHold(
      jumpBtn,
      function () { jump(); },
      function () {}
    );
    bindHold(
      duckBtn,
      function () {
        state.duckHeld = true;
        refreshDuck();
      },
      function () {
        state.duckHeld = false;
        refreshDuck();
      }
    );
    window.addEventListener("keydown", onKeyDown);
    window.addEventListener("keyup", onKeyUp);
    root.addEventListener("pointerdown", function () {
      audio.unlock();
    }, { passive: true });

    function syncMuteBtn() {
      if (!muteBtn) return;
      const on = audio.isMuted();
      muteBtn.setAttribute("aria-pressed", on ? "true" : "false");
      muteBtn.setAttribute("aria-label", on ? "Unmute sound" : "Mute sound");
      if (muteLabel) muteLabel.textContent = on ? "Unmute" : "Mute";
    }

    function syncVolumeInput() {
      if (!volumeInput) return;
      volumeInput.value = String(Math.round(audio.getVolume() * 100));
      volumeInput.setAttribute("aria-valuetext", Math.round(audio.getVolume() * 100) + " percent");
    }

    syncMuteBtn();
    syncVolumeInput();
    audio.onMuteChange(syncMuteBtn);
    audio.onSongChange(syncNowPlaying);
    if (nowPlayingEl) {
      nowPlayingEl.addEventListener("pointerdown", function (event) {
        event.stopPropagation();
      });
      nowPlayingEl.addEventListener("click", function (event) {
        event.stopPropagation();
      });
    }
    if (audioDock) {
      audioDock.addEventListener("pointerdown", function (event) {
        event.stopPropagation();
      });
      audioDock.addEventListener("click", function (event) {
        event.stopPropagation();
      });
    }
    if (muteBtn) {
      muteBtn.addEventListener("click", function (event) {
        event.preventDefault();
        event.stopPropagation();
        audio.unlock();
        audio.toggleMute();
      });
    }
    if (volumeInput) {
      volumeInput.addEventListener("input", function (event) {
        event.stopPropagation();
        audio.unlock();
        audio.setVolume(Number(volumeInput.value) / 100);
        syncMuteBtn();
      });
    }

    const loads = [
      loadImage(art.city && art.city.sky).then(function (img) { images.city.sky = img; }),
      loadImage(art.city && art.city.clouds).then(function (img) { images.city.clouds = img; }),
      loadImage(art.city && art.city.far).then(function (img) { images.city.far = img; }),
      loadImage(art.city && art.city.near).then(function (img) { images.city.near = img; }),
      loadImage(art.tiles && art.tiles.top).then(function (img) { images.tiles.top = img; }),
      loadImage(art.tiles && art.tiles.fill).then(function (img) { images.tiles.fill = img; }),
      loadImage(art.obstacles && art.obstacles.crate).then(function (img) { images.obstacles.crate = img; }),
      loadImage(art.obstacles && art.obstacles.crate2).then(function (img) { images.obstacles.crate2 = img; }),
      loadImage(art.obstacles && art.obstacles.barrel).then(function (img) { images.obstacles.barrel = img; }),
      loadImage(art.obstacles && art.obstacles.flag).then(function (img) { images.obstacles.flag = img; }),
      loadImage(art.obstacles && art.obstacles.locker).then(function (img) { images.obstacles.locker = img; }),
      loadImage(art.obstacles && art.obstacles.board).then(function (img) { images.obstacles.board = img; }),
      loadImage(art.obstacles && art.obstacles.pipe).then(function (img) { images.obstacles.pipe = img; }),
      loadImage(art.obstacles && art.obstacles.box).then(function (img) { images.obstacles.box = img; }),
      loadImage(art.obstacles && art.obstacles.box2).then(function (img) { images.obstacles.box2 = img; }),
      loadImage(art.obstacles && art.obstacles.capsule).then(function (img) { images.obstacles.capsule = img; }),
      loadImage(art.fx && art.fx.smoke).then(function (img) { images.fx.smoke = img; }),
      loadImage(art.fx && art.fx.sparks).then(function (img) { images.fx.sparks = img; }),
      loadImage(art.fx && art.fx.particles).then(function (img) { images.fx.particles = img; }),
      loadImage(art.signs && art.signs.billboard).then(function (img) {
        images.signs.billboard = img;
        images.signsGold.billboard = goldSignCopy(img);
      }),
      loadImage(art.signs && art.signs.poster).then(function (img) {
        images.signs.poster = img;
        images.signsGold.poster = goldSignCopy(img);
      }),
    ];
    CHARACTERS.forEach(function (ch) {
      images.chars[ch.id] = {};
      const pack = (art.chars && art.chars[ch.id]) || {};
      ["idle", "run", "jump", "death", "duck"].forEach(function (anim) {
        if (!pack[anim]) return;
        loads.push(
          loadImage(pack[anim]).then(function (img) {
            images.chars[ch.id][anim] = img;
          })
        );
      });
    });

    Promise.all(loads).then(async function () {
      await refreshStatus();
      syncPad();
      showMenu();
      draw();
      requestAnimationFrame(tick);
    });
  }

  document.querySelectorAll("[data-ovani-discount-game]").forEach(init);
})();
